module.exports = __webpack_public_path__ + "2390d700ecf8ae08b933acaf981e1217.svg";